export const IMPERSONATION_ACTIVITY = 'impersonation-activity';
export const IMPERSONATION_SESSION_EXPIRED = 'impersonation-session-expired';

const readFrameMarkerFromUrl = (): string | null => {
  if (typeof window === 'undefined' || window.parent === window) return null;
  return new URLSearchParams(window.location.search).get('impersonationFrame');
};

let frameMarker = readFrameMarkerFromUrl();

export const getImpersonationFrameMarker = (): string | null => {
  frameMarker ??= readFrameMarkerFromUrl();
  return frameMarker;
};

export const postToImpersonationParent = (type: string) => {
  const frameMarker = getImpersonationFrameMarker();
  if (!frameMarker) return;
  try {
    window.parent.postMessage({ type, frameMarker }, '*');
  } catch (error) {
    console.error(`Failed to post ${type} to the impersonation parent`, error);
  }
};

const isSessionExpiredStatus = (status: unknown): boolean =>
  status === 401 || status === 403;

export const isSessionExpiredError = (error: object): boolean => {
  if ('status' in error && isSessionExpiredStatus(error.status)) return true;
  return (
    'originalStatus' in error && isSessionExpiredStatus(error.originalStatus)
  );
};

const activeFrameMarkers = new Set<string>();

export const registerActiveFrameMarker = (marker: string) => {
  activeFrameMarkers.add(marker);
  return () => {
    activeFrameMarkers.delete(marker);
  };
};

export const isActiveFrameMarker = (marker: unknown): boolean =>
  typeof marker === 'string' && activeFrameMarkers.has(marker);
